<mat-dialog-content>
	<div class="searchWrapper flex flex-col justify-stretch">
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					[formControl]="search"
					cdkFocusInitial
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<div
					class="flex-center h-full"
					matSuffix
				>
					<mat-icon inline>search</mat-icon>
				</div>
			</mat-form-field>
		</div>
		<div class="searchContainer flex flex-col">
			<mat-list
				*ngIf="data$filtered | async as dataFiltered"
				dense
			>
				<ng-container *ngFor="let item of dataFiltered; trackBy: trackId">
					<mat-list-item
						(click)="this.selectItem(item)"
						[class.bg-primary-2]="item.selected"
						class="group cursor-pointer"
						matRipple
					>
						<div class="flex flex-auto items-center space-x-2.5">
							<div class="relative flex h-8 w-8 items-center justify-center">
								<app-user-avatar
									[ngClass]="{
                    'absolute rounded-full': true,
                    'opacity-40': item.selected,
                  }"
									[userId]="item.id"
									size="38px"
								></app-user-avatar>
								<div
									*ngIf="item.selected"
									class="z-10 flex-center h-8 w-8 rounded-full text-center text-lg leading-8"
								>
									<mat-icon inline>check</mat-icon>
								</div>
							</div>
							<div class="flex flex-auto flex-col leading-none">
								<span
									class="transition-transform duration-200 translate-y-2 group-hover:translate-y-0"
									>{{
										item.name
									}}</span
								>
								<span
									class="mat-hint text-sm opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-200"
									>{{
										item.email
									}}</span
								>
							</div>
							<div class="flex items-center space-x-1.5">
								<div class="text-lg leading-none">
									<mat-icon
										*ngIf="item.admin"
										class="mat-text-primary cursor-default"
										inline
										matTooltip="Administrator"
									>
										security
									</mat-icon>
								</div>
								@if (item.subordinate) {
								<div class="text-lg leading-none">
									<mat-icon
										[matTooltip]="'workspace.supervisors.subordinates' | translate"
										class="cursor-default"
										inline
									>
										supervisor_account
									</mat-icon>
								</div>
								}
							</div>
						</div>
					</mat-list-item>
				</ng-container>
				<ng-container *ngTemplateOutlet="noItems; context: { data: dataFiltered }"></ng-container>
			</mat-list>
			<ng-template
				#noItems
				let-dataFiltered="data"
			>
				<div
					*ngIf="dataFiltered.length === 0"
					class="flex flex-col items-center justify-center p-2"
				>
					<div class="mat-hint">{{ 'utils.noitems' | translate }}</div>
				</div>
			</ng-template>
		</div>
	</div>
</mat-dialog-content>
